import dateService from '../services/util/dateService'

var path = '/BuildingReconForm'

function get (http, id) {
    return http.get(path + `/Get?id=${id}&getComponents=true`)
}
function put (http, reconFormDto, saveComponent) {
    return http.put(path + '?saveComponents=' + saveComponent, reconFormDto)
}
function search (http, searchDto, getComponents = true) {
    return http.post(path + '/Search?getComponents=' + getComponents, searchDto).then(response => {
        response.data.forEach(value => {
            value.createdDate = dateService.convertToDate(value.createdDate)
            value.modifiedDate = dateService.convertToDate(value.modifiedDate)
        })
        return response
    })
}

function todo (http, searchDto) {
    return http.post(path + '/Todo', searchDto).then(response => {
        response.data.forEach(value => {
            value.createdDate = dateService.convertToDate(value.createdDate)
        })
        return response
    })
}

export default {
    get: get,
    put: put,
    search: search,
    todo: todo
}



// WEBPACK FOOTER //
// ./src/services/buildingReconFormService.js